'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    margin: 0 auto;\n    width: 50px;\n    height: 50px;\n    text-align: center;\n    font-size: 10px;\n  \n  & > div {\n    min-height: 100%;\n    width: 6px;\n    margin: 0 1px;\n    display: inline-block;\n    background: ', ';\n    -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;\n    animation: sk-stretchdelay 1.2s infinite ease-in-out;\n  }\n\n  .spinnerBit{\n    min-height: 100%;\n    width: 6px;\n    margin: 0 1px;\n  }\n  \n  & .rect2 {\n    -webkit-animation-delay: -1.1s;\n    animation-delay: -1.1s;\n  }\n  \n  & .rect3 {\n    -webkit-animation-delay: -1.0s;\n    animation-delay: -1.0s;\n  }\n  \n  & .rect4 {\n    -webkit-animation-delay: -0.9s;\n    animation-delay: -0.9s;\n  }\n  \n  & .rect5 {\n    -webkit-animation-delay: -0.8s;\n    animation-delay: -0.8s;\n  }\n  \n  @-webkit-keyframes sk-stretchdelay {\n    0%, 40%, 100% { -webkit-transform: scaleY(0.4) }  \n    20% { -webkit-transform: scaleY(1.0) }\n  }\n  \n  @keyframes sk-stretchdelay {\n    0%, 40%, 100% { \n      transform: scaleY(0.4);\n      -webkit-transform: scaleY(0.4);\n    }  20% { \n      transform: scaleY(1.0);\n      -webkit-transform: scaleY(1.0);\n    }\n  }\n'], ['\n    margin: 0 auto;\n    width: 50px;\n    height: 50px;\n    text-align: center;\n    font-size: 10px;\n  \n  & > div {\n    min-height: 100%;\n    width: 6px;\n    margin: 0 1px;\n    display: inline-block;\n    background: ', ';\n    -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;\n    animation: sk-stretchdelay 1.2s infinite ease-in-out;\n  }\n\n  .spinnerBit{\n    min-height: 100%;\n    width: 6px;\n    margin: 0 1px;\n  }\n  \n  & .rect2 {\n    -webkit-animation-delay: -1.1s;\n    animation-delay: -1.1s;\n  }\n  \n  & .rect3 {\n    -webkit-animation-delay: -1.0s;\n    animation-delay: -1.0s;\n  }\n  \n  & .rect4 {\n    -webkit-animation-delay: -0.9s;\n    animation-delay: -0.9s;\n  }\n  \n  & .rect5 {\n    -webkit-animation-delay: -0.8s;\n    animation-delay: -0.8s;\n  }\n  \n  @-webkit-keyframes sk-stretchdelay {\n    0%, 40%, 100% { -webkit-transform: scaleY(0.4) }  \n    20% { -webkit-transform: scaleY(1.0) }\n  }\n  \n  @keyframes sk-stretchdelay {\n    0%, 40%, 100% { \n      transform: scaleY(0.4);\n      -webkit-transform: scaleY(0.4);\n    }  20% { \n      transform: scaleY(1.0);\n      -webkit-transform: scaleY(1.0);\n    }\n  }\n']);

exports.Spinner = Spinner;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // const Dot = styled.div`
//     height: 20px;
//     width: 20px;
//     background: red
// `


function Spinner(_ref) {
  var style = _ref.style;
  return _react2.default.createElement(SpinnerStyles, {
    style: style,
    className: 'spinner'
  }, _react2.default.createElement('div', {
    className: 'rect1 spinnerBit'
  }), _react2.default.createElement('div', {
    className: 'rect2 spinnerBit'
  }), _react2.default.createElement('div', {
    className: 'rect3 spinnerBit'
  }), _react2.default.createElement('div', {
    className: 'rect4 spinnerBit'
  }), _react2.default.createElement('div', {
    className: 'rect5 spinnerBit'
  }));
}

var SpinnerStyles = _styledComponents2.default.div(_templateObject, function (_ref2) {
  var theme = _ref2.theme;
  return theme.brandColor;
});